import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { requestPasswordReset } from '../services/api';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await requestPasswordReset(email);
            toast.success(response.message);
        } catch (error) {
            toast.error('Error processing request');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[url('/public/background.jpg')] bg-cover bg-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow-2xl">
                <h2 className="text-3xl font-bold text-center">Forgot Password</h2>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Email Address
                        </label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
                    >
                        {isSubmitting ? 'Sending...' : 'Send Reset Instructions'}
                    </button>

                    <div className="text-sm text-center">
                        <a 
                            href="/login" 
                            className="font-medium text-blue-600 hover:text-blue-500"
                        >
                            Login
                        </a>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword; 